import { IBudgetConstruction } from '@apply/api/src/api/ApplyApi';
import { MoneyBox } from '@apply/components';
import { formatCurrencyOrUndefined } from '@apply/ui';
import { ApplicationQuestionReviewItem } from '../../../../components/ApplicationQuestionReviewItem';
import { useBudgetConstructionField } from '../../../../../queries/useBudgetConstructionField';

interface PlumbingProps {
    required?: boolean;
    propertyGuid: string;
    isReview?: boolean;
}

export const Plumbing: React.FC<PlumbingProps> = ({ required = false, propertyGuid, isReview = false }) => {
    const [plumbing, set_plumbing] = useBudgetConstructionField<number>(
        propertyGuid,
        (b) => b.values?.['Major Systems Rough-ins']?.['Plumbing'] ?? 0,
        (b, v) => ({ ...b, values: { ...b.values, 'Major Systems Rough-ins': { ...b.values?.['Major Systems Rough-ins'], 'Plumbing': v } } })
    );
    const label = 'Plumbing (except fixtures)';
    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={formatCurrencyOrUndefined(plumbing)}
                />
            ) : (
                <MoneyBox
                    id={'plumbing'}
                    allowNegative={false}
                    value={plumbing}
                    onChange={(value) => set_plumbing(value)}
                    required={required}
                    label={label}
                />
            )}
        </>
    );
};
